module.exports = __webpack_public_path__ + "scripts/icons.woff2?64b3e814";


//////////////////
// WEBPACK FOOTER
// ./semantic/dist/themes/default/assets/fonts/icons.woff2
// module id = 1486
// module chunks = 1